import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { put, takeLatest } from 'redux-saga/effects';
import { handleError } from 'redux/saga/utils/errorUtils';
import {
  AgentPerformanceCallMetricsRequest,
  AgentPerformanceCallMetricsResponse,
  AgentPerformanceMetricsResponse,
  fetchAgentPerformanceMetrics,
  fetchAgentPerformanceMetricsFailure,
  fetchAgentPerformanceMetricsSuccess,
  fetchAgentPerformanceStats,
  fetchAgentPerformanceStatsFailure,
  fetchAgentPerformanceStatsSuccess,
} from 'redux/slice/all-agent-performance/AgentPerformance.slice';
import { allAgentPerformanceEndpoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';

function* handleFetchAgentPerformanceCallMetricsSaga(
  action: PayloadAction<AgentPerformanceCallMetricsRequest>
) {
  const { supervisorId, startDate, endDate, limit, offset } = action.payload;
  try {
    const endpoint =
      allAgentPerformanceEndpoints.GET_AGENT_PERFORMANCE_CALL_METRICS(
        supervisorId,
        startDate,
        endDate,
        limit,
        offset
      );
    const response: AxiosResponse<AgentPerformanceCallMetricsResponse> =
      yield HTTPClient.GetRequest(endpoint);
    yield put(fetchAgentPerformanceStatsSuccess(response.data));
  } catch (error: any) {
    yield* handleError(error, fetchAgentPerformanceStatsFailure, '');
  }
}

function* handleFetchAgentPerformanceMetricsSaga(
  action: PayloadAction<AgentPerformanceCallMetricsRequest>
) {
  const { supervisorId, startDate, endDate, searchText, limit, offset } =
    action.payload;
  try {
    const endpoint = allAgentPerformanceEndpoints.GET_AGENT_PERFORMANCE_METRICS(
      supervisorId,
      startDate,
      endDate,
      searchText || '',
      limit,
      offset
    );
    const response: AxiosResponse<AgentPerformanceMetricsResponse> =
      yield HTTPClient.GetRequest(endpoint);
    yield put(fetchAgentPerformanceMetricsSuccess(response.data));
  } catch (error: any) {
    yield* handleError(error, fetchAgentPerformanceMetricsFailure, '');
  }
}

export function* watchAllAgentPerformanceSaga() {
  yield takeLatest(
    fetchAgentPerformanceStats.type,
    handleFetchAgentPerformanceCallMetricsSaga
  );
  yield takeLatest(
    fetchAgentPerformanceMetrics.type,
    handleFetchAgentPerformanceMetricsSaga
  );
}
